import type { JSX } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useWozCaseManager } from '../woz-case-manager.provider';

export const WozActiveCaseModal = (): JSX.Element => {
  const { caseManagerState, caseManagerViewModel } = useWozCaseManager();

  return (
    <Dialog open={caseManagerState.modals.showActiveCasePrompt} onClose={caseManagerViewModel.dismissActiveCasePrompt}>
      <DialogTitle>
        Actief bezwaar gevonden
        <IconButton
          aria-label='sluiten'
          onClick={caseManagerViewModel.dismissActiveCasePrompt}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Je hebt al een actief bezwaar. Wil je deze hervatten of een nieuw bezwaar starten?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={caseManagerViewModel.resumeActiveCase}>Hervatten</Button>
        <Button onClick={caseManagerViewModel.confirmNewCase} variant='contained'>
          Nieuw bezwaar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
